export default "__VITE_ASSET__CPJ_Eu0b__"